document.addEventListener("DOMContentLoaded", function () {
    const popup = document.getElementById("newsletterPopup");
    const closeButton = document.querySelector(".popup-close");
    const noThanksButton = document.querySelector(".popup-no-thanks");
    const form = document.querySelector("#newsletterPopup form");

    // Function to check if the popup should be shown
    function shouldShowPopup() {
        const subscribed = localStorage.getItem("newsletterSubscribed");
        const dismissedUntil = localStorage.getItem("newsletterDismissedUntil");

        if (subscribed) return false; // User has subscribed, never show again

        if (dismissedUntil) {
            const now = new Date().getTime();
            return now > parseInt(dismissedUntil); // Show only if 24 hours have passed
        }

        return true; // Show if no conditions block it
    }

    // Show the popup after 5 seconds if allowed
    setTimeout(() => {
        if (shouldShowPopup()) {
            popup.classList.add("show");
        }
    }, 5000);

    // Close popup on "No Thanks" click and set a 24-hour dismissal
    noThanksButton.addEventListener("click", function () {
        popup.classList.remove("show");
        const dismissUntil = new Date().getTime() + 24 * 60 * 60 * 1000; // 24 hours from now
        localStorage.setItem("newsletterDismissedUntil", dismissUntil);
    });

    // Close popup on clicking close button
    closeButton.addEventListener("click", function () {
        popup.classList.remove("show");
    });

    // When the form is submitted, store that the user subscribed
    form.addEventListener("submit", function () {
        localStorage.setItem("newsletterSubscribed", "true");
    });
});
